import { Platform } from "react-native";

/**
 * Mobile/desktop browsers only expose the camera in a "secure context".
 * - https:// origins (and a few exceptions like http://localhost) are secure.
 * - http://192.168.x.x / http://LAN_IP is NOT secure → getUserMedia returns denied with no OS prompt (especially Safari).
 */
export function isWebCameraBlockedByInsecureOrigin() {
  if (Platform.OS !== "web" || typeof window === "undefined") {
    return false;
  }
  return !window.isSecureContext;
}
